// Tarjeta del recibo para enviar por WhatsApp (se captura como imagen JPG).
// Mismo estilo que la cotizacion en version WhatsApp. Un recibo no es factura: no lleva IVA ni ReteIVA.
const fmt = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(Number(v) || 0);
const fechaCorta = iso => {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  return Number.isNaN(d.getTime()) ? String(iso).slice(0, 10) : d.toLocaleDateString('es-CO');
};
const fechaLarga = iso => {
  const d = iso ? new Date(`${String(iso).slice(0, 10)}T12:00:00`) : new Date();
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' });
};

export default function ReciboCard({ id = 'recibo-whatsapp-card', numero, fecha, cliente, infoCliente = {}, items = [], formaPago = '', observaciones = '' }) {
  const total = items.reduce((s, i) => s + (Number(i.valor) || 0), 0);
  const pagado = items.filter(i => i.estado === 'PAGADO').reduce((s, i) => s + (Number(i.valor) || 0), 0);
  const pendiente = total - pagado;
  return (
    <div id={id} style={{ width: 420, maxWidth: '100%', margin: '0 auto', background: '#fff', border: '1px solid #d8e5ec', borderRadius: 10, overflow: 'hidden', fontFamily: "'Space Grotesk', sans-serif", color: '#08293f' }}>
      <div style={{ background: '#08293f', color: '#fff', padding: '18px 20px 16px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 5, fontWeight: 800, letterSpacing: 3 }}>
          <span style={{ color: '#00b8e3', letterSpacing: -2, fontSize: 22 }}>{'//'}</span>
          <span style={{ color: '#fff', fontSize: 18 }}>AGE</span>
          <span style={{ color: 'rgba(255,255,255,0.58)', fontSize: 9, fontWeight: 400 }}>INFORMATICA</span>
        </div>
        <div style={{ marginTop: 20, display: 'grid', gap: 3 }}>
          <strong style={{ fontSize: 20 }}>Recibo {numero}</strong>
          <span style={{ color: 'rgba(255,255,255,0.68)', fontSize: 12 }}>{fechaLarga(fecha)}</span>
        </div>
      </div>
      <div style={{ padding: '14px 18px', background: '#f8fbfd', borderBottom: '1px solid #d8e5ec', fontSize: 12, color: '#5a7a8a', lineHeight: 1.5 }}>
        <strong style={{ display: 'block', color: '#08293f', fontSize: 15, marginBottom: 2 }}>AGE Informática</strong>
        Soporte técnico, mantenimiento e infraestructura TI<br />
        info@ageinformatica.com · 313 3030874<br />
        https://ageinformatica.com · Medellín, Colombia
      </div>
      <div style={{ padding: '16px 18px 10px' }}>
        <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 900, color: '#7f9aad', marginBottom: 5 }}>Recibo para</div>
        <h2 style={{ margin: 0, fontSize: 20, color: '#08293f' }}>{cliente}</h2>
        {(infoCliente.nit || infoCliente.direccion || infoCliente.correo) && (
          <div style={{ marginTop: 6, color: '#5a7a8a', fontSize: 12, lineHeight: 1.45 }}>
            {infoCliente.nit && <><span>NIT / CC: {infoCliente.nit}</span><br /></>}
            {infoCliente.direccion && <><span>Dirección: {infoCliente.direccion}</span><br /></>}
            {infoCliente.correo && <span>Correo: {infoCliente.correo}</span>}
          </div>
        )}
      </div>
      <div style={{ padding: '0 18px', display: 'grid', gap: 8 }}>
        {items.map((it, i) => (
          <div key={i} style={{ border: '1px solid #d8e5ec', background: '#fff', borderRadius: 7, padding: 10 }}>
            <h3 style={{ margin: 0, fontSize: 13, color: '#08293f' }}>{it.servicio || '—'}</h3>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, fontSize: 12, marginTop: 4, color: '#5a7a8a' }}>
              <span>{fechaCorta(it.fecha)}{it.solicitante ? ` · ${it.solicitante}` : ''}</span>
              <strong style={{ color: '#08293f' }}>{fmt(it.valor)}</strong>
            </div>
          </div>
        ))}
      </div>
      <div style={{ margin: '14px 18px 0', display: 'grid', gap: 6 }}>
        {pagado > 0 && pendiente > 0 && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#166534' }}><span>Pagado</span><strong>{fmt(pagado)}</strong></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#9a3412' }}><span>Saldo pendiente</span><strong>{fmt(pendiente)}</strong></div>
          </>
        )}
        <div style={{ background: '#f4f7fa', border: '1px solid #d8e5ec', borderRadius: 7, padding: 12, display: 'flex', justifyContent: 'space-between', fontSize: 16, fontWeight: 900, color: '#08293f' }}><span>Total</span><strong>{fmt(total)}</strong></div>
      </div>
      {(formaPago || observaciones) && (
        <div style={{ margin: '14px 18px 0', borderLeft: '3px solid #00b8e3', padding: '9px 11px', background: '#f8fbfd', color: '#5a7a8a', fontSize: 11, lineHeight: 1.45 }}>
          {formaPago && <div><strong style={{ color: '#08293f' }}>Forma de pago:</strong> {formaPago}</div>}
          {observaciones && <div style={{ marginTop: formaPago ? 4 : 0 }}>{observaciones}</div>}
        </div>
      )}
      <div style={{ marginTop: 16, padding: '14px 18px', background: '#08293f', color: 'rgba(255,255,255,0.74)', fontSize: 11, lineHeight: 1.5 }}>
        <strong style={{ color: '#fff' }}>AGE Informática</strong><br />
        Este recibo no constituye factura de venta.
      </div>
    </div>
  );
}
